module.exports = "//public.getcloudapp.com/packs/media/images/windows-b220ed87a042dab28df8d14d1e0673e2.svg";